import PropTypes from 'prop-types';
import Button from './Button';

const Buttons = ({ list, className = '' }) => {
  return (
    <div className={`flex flex-col gap-4 mb-4 lg:flex-row lg:flex-wrap lg:gap-3 lg:justify-end ${className}`}>
      {list.map((button) => (
        <Button key={button.id} {...button} />
      ))}
    </div>
  );
};

Buttons.propTypes = {
  list: PropTypes.array.isRequired,
  className: PropTypes.string,
};

export default Buttons;
